export default __webpack_public_path__ + "static/media/author-photo.png";